﻿var vm;
(function () {
    'use strict';
    var controllerId = 'equipmentStockCtrl';
    angular
        .module('app.controllers')
        .controller(controllerId, equipmentStockCtrl);

    equipmentStockCtrl.$inject = ['common', 'datacontext', '$http', '$scope', '$rootScope', '$state', '$stateParams', '$translate', '$window', '$timeout', '$compile', 'moment'];

    function equipmentStockCtrl(common, datacontext, $http, $scope, $rootScope, $state, $stateParams, $translate, $window, $timeout, $compile,moment) {
        var config = common.config;
        vm = this;

        vm.carrierName = "";
        vm.carrierModel = null;
        vm.export = false;
        vm.listDepot = [];
        vm.yardModel = null;

        vm.listBoxCondition = [];
        vm.boxConditionModel = null;

        vm.listReeferCondition = [];
        vm.reeferConditionModel = null;

        vm.familyList = [];
        vm.familyModel = null;

        vm.listSizeType = [];
        vm.sizeTypeModel = null;

        vm.equipmentNo = "";
        vm.reportDate = null;

        vm.equipmentStockList = [];

        var selectOption = { Id: 0, Name: 'Seleccione' }
        var listSizeTypeOriginal = [];

        //Pagination config
        vm.total = 0;
        vm.countPartial = 10;
        vm.initialposition = 1;

        vm.displayLoading = false;
        vm.displayInfoNoData = true;
        vm.disabledBtnSearch = false;
        vm.roleSelected = "";
        vm.isAdmin = false;

        vm.equipmentStockData = [];
        vm.equipmentStockDataSource = { data: vm.equipmentStockData };

        function init() {
            vm.initializeControls();
            vm.setBasicInformation();
            common.activateController([vm.initialReferenceData()]).then(function (data) {});

            vm.equipmentStockDataSource = new kendo.data.DataSource({
                data: vm.equipmentStockData
            });
    
            vm.gridOptions = {
                dataSource: vm.equipmentStockDataSource,
                sortable: false,
                pageable: {pageSizes: [10, 20, 30,50,100]},
                groupable: false,
                resizable: true,
                scrollable: true,
                height: 400,
                columns: [
                    { 
                        field: "YardName", 
                        title: $translate.instant('views.equipmentstock.depot'),
                        width: "200px" },
                    {
                        title: $translate.instant('views.equipmentstock.eir'),
                        field: "EIR",
                        width: "150px"
                    },
                    {
                        title: $translate.instant('views.equipmentstock.carrier'),
                        field: "Carrier",
                        width: "200px"
                    },
                    {
                        title: $translate.instant('views.equipmentstock.equipmentNo'),
                        field: "EquipmentNo",
                        width: "150px"
                    },
                    {
                        title: $translate.instant('views.equipmentstock.sizeType'),
                        field: "SizeType",
                        width: "150px"
                    },
                    {
                        title: $translate.instant('views.equipmentstock.tatcNo'),
                        field: "TATCNo",
                        width: "150px"
                    },
                    {
                        title: $translate.instant('views.equipmentstock.tareWeight'),
                        field: "TareWeight",
                        width: "100px"
                    },
                    {
                        title: $translate.instant('views.equipmentstock.Weight'),
                        field: "Weight",
                        width: "100px"
                    },
                    {
                        title: $translate.instant('views.equipmentstock.buildDate'),
                        field: "BuildDate",
                        width: "150px",
                        template: "#= kendo.toString(kendo.parseDate(BuildDate), 'dd-MM-yyyy') #"
                    },
                    {
                        title: $translate.instant('views.equipmentstock.indate'),
                        field: "InDate",
                        width: "150px",
                        template: "#= kendo.toString(kendo.parseDate(InDate), 'dd-MM-yyyy') #"
                    },
                    {
                        title: $translate.instant('views.equipmentstock.intime'),
                        field: "InDate",
                        width: "150px",
                        template: "#= kendo.toString(kendo.parseDate(InDate), 'HH:mm') #"
                    },
                    {
                        title: $translate.instant('views.equipmentstock.daysOnDeposit'),
                        field: "Storage",
                        width: "100px"
                    },
                    {
                        title: $translate.instant('views.equipmentstock.class'),
                        field: "EquipmentClass",
                        width: "200px"
                    },
                    {
                        title: $translate.instant('views.equipmentstock.refeertype'),
                        field: "RefeerType",
                        width: "200px"
                    },
                    {
                        title: $translate.instant('views.equipmentstock.boxCondition'),
                        field: "BoxCondition",
                        width: "200px"
                    },
                    {
                        title: $translate.instant('views.equipmentstock.reeferCondition'),
                        field: "ReeferCondition",
                        width: "200px"
                    },
                    {
                        title: $translate.instant('views.equipmentstock.caCondition'),
                        field: "CACondition",
                        width: "200px"
                    },
                    {
                        title: $translate.instant('views.equipmentTracking.Blocks'),
                        field: "Block",
                        width: "300px"
                    },
                    {
                        title: $translate.instant('views.equipmentstock.holdremarks'),
                        field: "HoldRemarks",
                        width: "300px"
                    }
                ]
            };
        };

        vm.setBasicInformation = function () {
            var now = moment();
            var authData = common.localStorageService.get('authorizationData');
            vm.roleSelected = authData ? authData.userRole : "";
            vm.isAdmin = vm.roleSelected === "COPAdminP" ? true : false;
            // vm.reportDate = now.format("DD/MM/YYYY");
            // $('#dtp_Date').datepicker('setDate', vm.reportDate);
        }
        vm.initializeControls = function () {
            $('#dtp_Date').datepicker({
                autoclose: true,
                format: 'dd/mm/yyyy',
                endDate: new Date(new Date().setDate(new Date().getDate()))
                //endDate: new Date(new Date().setDate(new Date().getDate() - 1))
            });
        }

        vm.focusDate = function () {
            $('#dtp_Date').focus();
        };
        

        vm.initialReferenceData = function () {
            return datacontext.equipmentstock.getFilters(vm.roleSelected)
                .then(function (data) {
                    if (data) {
                        var dataYards = common.localStorageService.get('yardList');
                        var currentYard = $(dataYards).filter(function (a, b) { return b.currentYard == "currentYard"; })[0];
                        var currentDepot = $(data.Depot).filter(function (e, v) { return v.DependentId == currentYard.groupId })[0];

                        if (currentDepot)
                            vm.yardModel = currentDepot;

                        vm.listDepot = data.Depot ? data.Depot : [];
                        vm.listDepot.unshift(selectOption);
                        vm.yardModel = vm.listDepot[0];
                        vm.fnSetDefaultDepot();

                        vm.listBoxCondition = angular.copy(data.BoxCondition);
                        vm.listBoxCondition.unshift(selectOption);
                        vm.boxConditionModel = vm.listBoxCondition[0];

                        vm.listReeferCondition = angular.copy(data.ReferCondition);
                        vm.listReeferCondition.unshift(selectOption);
                        vm.reeferConditionModel = vm.listReeferCondition[0];

                        vm.familyList = angular.copy(data.FamilyList);
                        vm.familyList.unshift(selectOption);
                        vm.familyModel = vm.familyList[0];

                        listSizeTypeOriginal = angular.copy(data.SizeType);
                        vm.listSizeType = angular.copy(listSizeTypeOriginal);
                        vm.listSizeType.unshift(selectOption);
                        vm.sizeTypeModel = vm.listSizeType[0];

                        vm.carrierName = data.Carrier;
                        vm.carrierModel = data.CarrierId;

                        vm.disabledBtnSearch = false;
                    }
                }, function (err) {
                    if (err.status)
                        toastr.error(err.info);
                });
        };

        function fnGetEquipmentStock() {
            // var valid = vm.fnValidateMandatoryFields();
            // if (!valid) return;
            
            vm.displayLoading = true;
            vm.displayInfoNoData = false;
            vm.disabledBtnSearch = true;
            vm.total = 0;
            vm.equipmentStockList = [];

            vm.equipmentStockDataSource = SetDataSourceAsync(config.basePaths.Base_Path_Resources + 'reportList/GetEquipmentStock',null, "mainReport", 10);

            vm.disabledBtnSearch = false;
            vm.displayLoading = false;
        };

        function SetDataSourceAsync(url, modelSchema, grid, pageSize) {
            var ds = new kendo.data.DataSource({
                transport: {
                    read: {
                        url: url,
                        type: "POST",
                        beforeSend: function (request) {
                            showLoader();
                            var authData = common.localStorageService.get('authorizationData');
                            request.setRequestHeader("Authorization", "Bearer " + authData.access_token);
                            request.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                            request.setRequestHeader('ModelRequester', JSON.stringify(authData.ModelRequester));
                            request.async = false;
                        },
                        complete: function (data, status) {
                            dismissLoader();
                            console.log("SetDataSourceAsync_complete status: " + status);
                            if (status === "success") {
                                // if (grid)
                                //     $("#" + grid).data("kendoGrid").refresh();
                                vm.total = data.responseJSON.Total;
                            }
                            else if (status === "error" || status === "parsererror") {
                                console.log("Ha ocurrido un error al procesar la solicitud.");
                            }
                            else if (status == "timeout") {
                                console.log("Se ha superado el tiempo de espera.");
                            }
                            else {
                                console.log(status);
                            }
                        }
                    },
                    parameterMap: function (options) {
                        var model = fnGetParametersToSearchDepotOrder(vm.initialposition, vm.countPartial)
                        model.parameters = options;
                        return JSON.stringify(model);
                    }
                },
                schema: { data: "List", total: "Total", model: modelSchema },
                pageSize: pageSize ? pageSize : 10,
                serverPaging: true,
                error: function(xhr, error) {
                    dismissLoader();
                }
            });
            return ds;
        }

        function fnExportEquipmentStock() {
            
            let criteria = fnGetParametersToSearchDepotOrder(1, 2000);
            let url_ = config.basePaths.Base_Path_Resources + 'reportList/ExportEquipmentStock';
            var authData = common.localStorageService.get('authorizationData');
            const fileName = 'InventarioContenedores';
            var request = new XMLHttpRequest();
            request.open('POST', url_, true);
            request.setRequestHeader("Authorization", "Bearer " + authData.access_token);
            request.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            request.setRequestHeader('ModelRequester', JSON.stringify(authData.ModelRequester));
            request.responseType = 'blob';
            showLoader();
            request.onload = function (e) {
                dismissLoader();
                if (this.status === 200) {
                    var blob = this.response;
                    if (window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveBlob(blob, fileName);
                    }
                    else {
                        var downloadLink = window.document.createElement('a');
                        var contentTypeHeader = request.getResponseHeader("Content-Type");
                        downloadLink.href = window.URL.createObjectURL(new Blob([blob], { type: contentTypeHeader }));
                        downloadLink.download = fileName;
                        document.body.appendChild(downloadLink);
                        downloadLink.click();
                        document.body.removeChild(downloadLink);
                    }
                }
            };
            request.send(JSON.stringify(criteria));
        };

        function fnGetParametersToSearchDepotOrder(pageNumber, pageSize) {
            var authData = common.localStorageService.get('authorizationData');
            var rolesUser = common.localStorageService.get('GetRolesByUserQuery');
            var searchCriteria = {
                CarrierId: vm.carrierModel,
                YardId: vm.yardModel && vm.yardModel.Id > 0 ? vm.yardModel.Id : null,
                FamilyId: vm.familyModel && vm.familyModel.Id > 0 ? vm.familyModel.Id : null,
                BoxConditionId: vm.boxConditionModel && vm.boxConditionModel.Id > 0 ? vm.boxConditionModel.Id : null,
                ReeferConditionId: vm.reeferConditionModel && vm.reeferConditionModel.Id > 0 ? vm.reeferConditionModel.Id : null,
                SizeTypeId: vm.sizeTypeModel && vm.sizeTypeModel.Id > 0 ? vm.sizeTypeModel.Id : null,
                EquipmentNo: vm.equipmentNo,
                ReportDate: vm.reportDate ? vm.fnConvertDateToSQLFormat(vm.reportDate) : null,
                pageNumber: parseInt(pageNumber),
                pageSize: parseInt(pageSize),
                userName: authData.username,
                languageId: authData.ModelRequester.DefaultLanguageId,
                IsRolCarrier: rolesUser.isCarrier,
                parameters : { page: 1, take: 2000 }
            }
            return searchCriteria;
        };

        vm.fnConvertDateToSQLFormat = function (date) {
            let parseDate = null;
            if (date != undefined && date != '') {
                var splitDate = date.split("/");
                parseDate = splitDate[1] + '/' + splitDate[0] + '/' + splitDate[2];
            }
            return parseDate;
        }

        // vm.fnValidateMandatoryFields = function(){
        //     var message = ""
        //     if(vm.reportDate == "" || vm.reportDate == null)
        //      {
        //         message = $translate.instant('views.stocksummary.dateRequired'); 
        //         toastr.error(message);
        //         return false;
                
        //      }
        //      return true;  
        // }

        function fnClearEquipmentStockSearch() {
            $scope.$broadcast('angucomplete-alt:clearInput');

            vm.carrierModel = null;

            //vm.yardModel = vm.listDepot[0];
            vm.boxConditionModel = vm.listBoxCondition[0];
            vm.reeferConditionModel = vm.listReeferCondition[0];
            vm.familyModel = vm.familyList[0];
            vm.listSizeType = angular.copy(listSizeTypeOriginal);
            vm.listSizeType.unshift(selectOption);
            vm.sizeTypeModel = vm.listSizeType[0];

            vm.equipmentNo = "";
            vm.reportDate = null;

            vm.equipmentStockList = [];
            vm.equipmentStockDataSource = null;

            vm.total = 0;
            vm.countPartial = 10;
            vm.initialposition = 1;
        }


        vm.fnSetDefaultDepot = function() {
            var authData = common.localStorageService.get('authorizationData');
            if (authData) {
                var currentYardId = authData.ModelRequester.CurrentYardId;
                if (currentYardId !== undefined)
               var selectyard = vm.listDepot.filter(function(item){return item.Id ==currentYardId })[0]
                if(selectyard !== undefined || selectyard !== null)
                     vm.yardModel = selectyard;
            }
        }

        vm.search = function () {
            fnGetEquipmentStock();
        }

        vm.clear = function () {
            fnClearEquipmentStockSearch();
        };

        vm.exportEquipmentStock = function () {
            fnExportEquipmentStock();
        };

        vm.changeFamily = function () {
            vm.listSizeType = [];
            if (vm.familyModel.Id > 0) {
                angular.forEach(listSizeTypeOriginal, function (val, key) {
                    if (vm.familyModel.Code == val.Aditional) {
                        vm.listSizeType.push(val);
                    }
                });
                vm.listSizeType.unshift(selectOption);
                vm.sizeTypeModel = vm.listSizeType[0];
            } else {
                vm.listSizeType = angular.copy(listSizeTypeOriginal);
                vm.listSizeType.unshift(selectOption);
                vm.sizeTypeModel = vm.listSizeType[0];
            }
        }

        vm.getCarrierByName = function (name) {
            return datacontext.progressdepotorder.getCarrierByName(name);
        };

        vm.selectedCarrierFn = function (selected) {
            if (selected != undefined) {
                vm.carrierName = selected.originalObject.Name;
                vm.carrierModel = selected.originalObject.BusinessPartnerId;
            } else {
                vm.carrierName = null;
                vm.carrierModel = null;
            }
        };

        function showLoader() {
            if ($(".custom-loader-div").length == 0) {
                $('body').prepend("<div class='custom-loader-div'><div class='custom-loader-image'/></div>");
                $('.custom-loader-div').attr("data-loadernumber", 0);
            }

            var loadernumber = $('.custom-loader-div').attr("data-loadernumber");
            $('.custom-loader-div').attr("data-loadernumber", ++loadernumber);

        }

        function dismissLoader() {
            var loadernumber = $('.custom-loader-div').attr("data-loadernumber");
            $('.custom-loader-div').attr("data-loadernumber", --loadernumber);

            if ($('.custom-loader-div').attr("data-loadernumber") == 0) {
                $(".custom-loader-div").remove();
            }
        }

        init();
    }
})();